
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
import Vue from 'vue'
import Router from 'vue-router'
import { scrollBehavior } from '@/utils/keepAlive'

import layout from '@/views/layout/index.vue'
import routerView from '@/views/layout/routerView'
import { searchRoute } from '@/views/search/router'
import { junbrosRoute } from '@/views/junbros/router'
import { inquiryRoute } from '@/views/inquiry/router'
import { callRoute } from '@/views/call/router'
import { talkManageRoute } from '@/views/talkManage/router'

// import { clueRoute } from '@/views/clue/router'
// import { commercialMapRoute } from '@/views/commercialMap/router'
import { industryChainRoute } from '@/views/industryChainNew/router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    console.log(err)
    if (err.name === 'NavigationDuplicated') {
      return Promise.resolve()
    }
    return Promise.reject(err)
  })
}

Vue.use(Router)
let routes = [
  { path: '/', redirect: '/zxk/home' },
  { path: '/clue/index', redirect: '/zxk/home' }, // 原有首页地址
  { path: '/403', component: () => import('@/views/403'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/enterpriseDetail', component: () => import('@/views/enterpriseDetail'), hidden: true },
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/redirect',
    component: () => import('@/views/redirect'),
    hide: true,
    children: [
      {
        path: '',
        meta: {},
        component: layout,
        children: [
          {
            path: '/redirect/:path(.*)',
            component: () => import('@/views/redirect')
          }
        ]
      }
    ],
    meta: { code: '*' }
  },
]
const allRoute = [{
  path: '/zxk',
  name: 'zxk',
  title: '首页',
  component: layout,
  hidden: false,
  full: false,
  children: [
    {
      path: 'home',
      name: '首页',
      component: () => import('@/views/home/page/index.vue'),
      icon: 'icon-shouyefill',
      icon_img: 'nav01',
      hidden: false,
      meta: {
        nextStart: true,
        title: '首页',
        // breadcrumb: ['首页']
      }
    },
    ...searchRoute,
    ...junbrosRoute,
    ...inquiryRoute,
    ...industryChainRoute,
    ...talkManageRoute,
    // {
    //   path: 'talk',
    //   name: '智能拓客',
    //   icon: 'icon-zhinengtuoke',
    //   hidden: false,
    //   hide: false,
    //   component: routerView,
    //   children: searchRoute.concat(junbrosRoute, inquiryRoute, talkManageRoute)
    // }
    // { // 暂时不上
    //   path: 'reach',
    //   name: '智能触达',
    //   icon: 'icon-yingxiaochuda',
    //   hidden: false,
    //   component: routerView,
    //   children: callRoute
    // }
    // {
    //   path: 'transition',
    //   name: '智能转换',
    //   icon: 'icon-xiansuo2',
    //   hidden: false,
    //   children: []
    // }
  ]
}]
routes = routes.concat(allRoute)

export default function (store) {
  const routeInfo = {
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
    scrollBehavior: scrollBehavior(store)
  }
  const router = new Router(routeInfo)

  router.$addRoutes = (params, parent) => {
    router.matcher = new Router(routeInfo).matcher
    params.forEach((x) => {
      if (parent) {
        router.addRoute(parent, x) // 添加路由

      } else {
        router.addRoute(x) // 添加路由
      }
    })
  }
  router.beforeEach(async (to, from, next) => {
    // TODO 先禁用
    // store.commit('clearToken') // 取消请求
    // window._codeNum610 = 0
    // 加载异步路由
    // if (!store.state.asyncRoute.isGetRoute) {
    //   const res = await store.dispatch('getRouters')
    //   router.$addRoutes(res, 'zxk')
    //   const index = router.options.routes.findIndex(e => e.name === 'zxk')
    //   router.options.routes[index].children = router.options.routes[index].children.concat(res)

    //   if (to.redirectedFrom) {
    //     router.replace(to.redirectedFrom)
    //   } else {
    //     next({ ...to, replace: true })
    //   }
    // } 
    next()
    // next()
  })
  return router
}
